const allBlogTitle = 'Support Articles'

// 所有帮助中心的博客分类
const BLOG_CATEGORIES = [
  allBlogTitle,
  'Getting Started',
  'Network',
  'Password',
  'Function Setup',
  'Troubleshooting',
  'Orders & Shipping'
];

let allArticles = [];
let currentBlogTitle = '';
let currentPage = 1;
let totalPages = 1; // ← 新增
const ARTICLES_PER_PAGE = 10;

// ✅ 从 URL 获取 blogTitle 和 page
function getParamsFromURL() {
  const params = new URLSearchParams(window.location.search);
  let blogTitle = params.get('blogTitle') || allBlogTitle;
  if (blogTitle.trim() == 'Orders') {
    blogTitle = 'Orders & Shipping'
  }
  // blogTitle = 'News';
  const page = parseInt(params.get('page'), 10) || 1;
  return { blogTitle, page };
}

// ✅ 更新 URL（同时设置 blogTitle 和 page）
function updateURL(blogTitle, page) {
  if (blogTitle.trim() == 'Orders') {
    blogTitle = 'Orders & Shipping'
  }
  const url = new URL(window.location);
  url.searchParams.set('blogTitle', blogTitle);
  url.searchParams.set('page', page);
  window.history.replaceState({}, '', url);
}

// 渲染下拉框（不变）
function createCategorySelect(currentTitle) {
  const select = document.createElement('select');
  select.id = 'blog-category-select';

  BLOG_CATEGORIES.forEach(category => {
    const option = document.createElement('option');
    option.value = category;
    option.textContent = category;
    option.selected = (category === currentTitle);
    select.appendChild(option);
  });

  select.addEventListener('change', (e) => {
    const newTitle = e.target.value;
    updateURL(newTitle, 1); // 切换分类，重置到第 1 页
    fetchAndRenderBlog();
  });

  return select;
}

// 渲染某一页的文章
function renderPageToContainer(ulElement, articles, page) {
  ulElement.style.transition = 'none';
  ulElement.innerHTML = '';
  const start = (page - 1) * ARTICLES_PER_PAGE;
  const pageArticles = articles.slice(start, start + ARTICLES_PER_PAGE);

  pageArticles.forEach(article => {
    const li = document.createElement('li');
    const link = document.createElement('a');
    link.href = article.onlineStoreUrl;
    link.textContent = article.title;
    const excerpt = document.createElement('p');
    excerpt.textContent = article.excerpt;
    li.append(link, excerpt);
    ulElement.appendChild(li);
  });

  // 强制重排
  void ulElement.offsetHeight;

  // 计算真实高度（至少 150）
  const realHeight = Math.max(ulElement.scrollHeight, 150);
  ulElement.style.transition = 'height 0.5s ease-in-out';
  ulElement.style.height = `${realHeight}px`;
}

// ✨ 全新分页控件（带省略号、上一页/下一页、CSS 下划线）
function createPagination(total, currentPage, totalPages, onPageChange) {
  if (totalPages <= 1) return null;

  const div = document.createElement('div');
  div.className = 'pagination';
  div.style.marginTop = '2rem';
  div.style.textAlign = 'center';
  div.style.display = 'flex';
  div.style.justifyContent = 'start';
  div.style.gap = '6px';

  // 上一页
  const prevBtn = document.createElement('button');
  prevBtn.textContent = '‹';
  prevBtn.disabled = currentPage === 1;
  prevBtn.onclick = () => onPageChange(currentPage - 1);
  Object.assign(prevBtn.style, {
    padding: '4px 8px',
    border: 'none',
    fontSize: '25px',
    background: '#fff',
    cursor: 'pointer'
  });
  div.appendChild(prevBtn);

  // 生成页码（智能省略）
  let pagesToShow = [];
  if (totalPages <= 5) {
    for (let i = 1; i <= totalPages; i++) pagesToShow.push(i);
  } else {
    pagesToShow.push(1);
    if (currentPage <= 3) {
      pagesToShow.push(2, 3, '...', totalPages);
    } else if (currentPage >= totalPages - 2) {
      pagesToShow.push('...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pagesToShow.push('...', currentPage, '...', totalPages);
    }
  }

  pagesToShow.forEach(page => {
    if (page === '...') {
      const span = document.createElement('span');
      span.textContent = '...';
      span.style.padding = '4px 8px';
      div.appendChild(span);
    } else {
      const btn = document.createElement('button');
      btn.textContent = page;
      btn.dataset.page = page; // 标记页码
      btn.onclick = () => onPageChange(page);
      Object.assign(btn.style, {
        padding: '4px 8px',
        border: 'none',
        fontSize: '18px',
        background: '#fff',
        cursor: 'pointer',
        position: 'relative'
      });
      if (page === currentPage) {
        btn.classList.add('current-page');
      }
      div.appendChild(btn);
    }
  });

  // 下一页
  const nextBtn = document.createElement('button');
  nextBtn.textContent = '›';
  nextBtn.disabled = currentPage === totalPages;
  nextBtn.onclick = () => onPageChange(currentPage + 1);
  Object.assign(nextBtn.style, {
    padding: '4px 8px',
    border: 'none',
    fontSize: '25px',
    background: '#fff',
    cursor: 'pointer'
  });
  div.appendChild(nextBtn);

  return div;
}

// 更新分页按钮高亮（避免重建整个分页）
function updatePaginationHighlight(paginationEl, currentPage) {
  if (!paginationEl) return;
  paginationEl.querySelectorAll('button').forEach(btn => {
    const page = parseInt(btn.dataset.page, 10);
    if (!isNaN(page)) {
      btn.classList.toggle('current-page', page === currentPage);
    }
    // 使用全局 totalPages 判断禁用
    if (btn.textContent === '‹') {
      btn.disabled = currentPage <= 1;
    } else if (btn.textContent === '›') {
      btn.disabled = currentPage >= totalPages; // ← 关键修复！
    }
  });
}

// 主渲染函数
// 主渲染函数（含分页重建）
function renderBlogArticles(blogTitle, articles, initialPage) {
  const desktopContainer = document.querySelector('#supportCenter_helpblogs .container');
  const mobileContainer = document.querySelector('#supportCenter_helpblogs_mobile .container');
  if (!desktopContainer || !mobileContainer) return;

  allArticles = articles;
  currentBlogTitle = blogTitle;
  const calculatedTotalPages = Math.ceil(articles.length / ARTICLES_PER_PAGE);
  let currentPage = Math.max(1, Math.min(initialPage, calculatedTotalPages));

  // ====== 桌面端 ======
  desktopContainer.innerHTML = '';

  const topHeader = document.createElement('div');
  topHeader.className = 'topHeader';
  topHeader.innerHTML = `
    <div class="bread"><a href="https://cyviolife.com/pages/supportcenter">Knowledgebase</a><span>/</span><a href="https://cyviolife.com/pages/helpblogs">Help</a></div>
    <div class="search"><input type="text" placeholder="Search by product name or SKU"></div>
  `;
  desktopContainer.appendChild(topHeader);

  const titleEl = document.createElement('h2');
  titleEl.textContent = `${blogTitle} (${articles.length})`;
  desktopContainer.appendChild(titleEl);

  const selectEl = createCategorySelect(blogTitle);
  desktopContainer.appendChild(selectEl);

  const listEl = document.createElement('ul');
  desktopContainer.appendChild(listEl);

  // 渲染当前页文章
  renderPageToContainer(listEl, articles, currentPage);

  // ✅ 分页点击处理函数（闭包捕获当前 articles 和 blogTitle）
  const handlePageChange = (newPage) => {
    // 更新 URL
    updateURL(currentBlogTitle, newPage);
    // 重新渲染整个 UI（包括分页）—— 这是关键！
    renderBlogArticles(currentBlogTitle, allArticles, newPage);
  };

  // 创建分页（传入当前页和总页数）
  const paginationEl = createPagination(articles.length, currentPage, calculatedTotalPages, handlePageChange);
  if (paginationEl) {
    desktopContainer.appendChild(paginationEl);
  }

  // ====== 移动端 ======
  mobileContainer.innerHTML = '';

  // 1. 添加 topHeader（克隆桌面端的）
  mobileContainer.appendChild(topHeader.cloneNode(true));

  // 2. 添加标题
  mobileContainer.appendChild(titleEl.cloneNode(true));

  // 3. 添加下拉框（⚠️ 不能直接 clone，因为事件监听器不会被复制！）
  const mobileSelectEl = createCategorySelect(blogTitle); // 重新创建一个
  mobileContainer.appendChild(mobileSelectEl);

  // 4. 文章列表
  const mobileListEl = document.createElement('ul');
  mobileContainer.appendChild(mobileListEl);
  renderPageToContainer(mobileListEl, articles, currentPage);

  // 5. 分页（如果存在）
  if (paginationEl) {
    const mobilePagination = paginationEl.cloneNode(true);
    mobileContainer.appendChild(mobilePagination);

    // 绑定移动端分页按钮 → 触发桌面端逻辑
    const desktopButtons = Array.from(desktopContainer.querySelectorAll('.pagination button'));
    const mobileButtons = mobileContainer.querySelectorAll('.pagination button');
    mobileButtons.forEach((btn, index) => {
      btn.onclick = () => {
        desktopButtons[index]?.click();
      };
    });
  }
}

// 获取并渲染博客
async function fetchAndRenderBlog() {
  const { blogTitle, page } = getParamsFromURL();

  let articles = [];

  if (blogTitle === allBlogTitle) {
    // ✅ 并行请求所有分类的文章
    const promises = BLOG_CATEGORIES.map(category => {
      const query = `
        query {
          blogs(first: 1, query: "title:'${category}'") {
            nodes {
              articles(first: 50) {
                nodes {
                  title
                  onlineStoreUrl
                  excerpt
                }
              }
            }
          }
        }
      `;
      return fetch('https://cyviolife.com/api/2026-01/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query })
      })
        .then(res => res.json())
        .then(data => {
          return data?.data?.blogs?.nodes?.[0]?.articles?.nodes || [];
        })
        .catch(err => {
          console.warn(`Failed to fetch category: ${category}`, err);
          return []; // 出错也返回空数组，不影响整体
        });
    });

    // 等所有请求完成，合并结果
    const allResults = await Promise.all(promises);
    articles = allResults.flat(); // 合并成一维数组
  } else {
    // 单分类模式
    const query = `
      query MyQuery {
        blogs(first: 1, query: "title:'${blogTitle}'") {
          nodes {
            articles(first: 50) {
              nodes {
                title
                onlineStoreUrl
                excerpt
              }
            }
          }
        }
      }
    `;

    const response = await fetch('https://cyviolife.com/api/2026-01/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query })
    });

    const data = await response.json();
    articles = data?.data?.blogs?.nodes?.[0]?.articles?.nodes || [];
  }
  // 搜索接口函数
  initHelpBlogsSearch()
  renderBlogArticles(blogTitle, articles, page);
}

// 页面加载
document.addEventListener('DOMContentLoaded', fetchAndRenderBlog);

// ✅ 添加 CSS 样式（下划线）
const style = document.createElement('style');
style.textContent = `
  .pagination .current-page {
    color: #007bff;
    font-weight: bold;
  }
  .pagination .current-page::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #007bff;
  }
`;
document.head.appendChild(style);